import React, { useState, useEffect } from "react";
import { request, gql } from "graphql-request";
import { hyGraphToken, endpointURL } from "../ThemeModule";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import "./caseStudy/casestudy.scss";
import Seo from "../components/Seo";
import { ROUTE_META, SITE_URL, breadcrumbSchema } from "../seo/siteMeta.mjs";

const caseStudiesSchema = [
  {
    "@type": "CollectionPage",
    name: ROUTE_META["/case-studies"].title,
    description: ROUTE_META["/case-studies"].description,
    url: `${SITE_URL}/case-studies`,
    isPartOf: { "@id": `${SITE_URL}/#website` },
  },
  breadcrumbSchema([
    { name: "Home", path: "/" },
    { name: "Case Studies", path: "/case-studies" },
  ]),
];

const CaseStudies = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      const query = gql`
        query {
          caseStudies {
            title
            slug
            featureImage {
              url
            }
          }
        }
      `;

      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${hyGraphToken}`,
      };

      try {
        const data = await request(endpointURL, query, {}, headers);
        setPosts(data.caseStudies);
      } catch (error) {
        console.error("Error fetching posts:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return (
    <>
      <Seo
        path="/case-studies"
        title={ROUTE_META["/case-studies"].title}
        description={ROUTE_META["/case-studies"].description}
        schema={caseStudiesSchema}
      />

      <PageHeader title="Case Studies" />
      <section className="blog page-section relative shape-1 shape-2">
        <div className="max-w-container mx-auto px-4">
          {loading ? (
            <div className="loader">Loading...</div>
          ) : error ? (
            <div className="error-message">
              <p>Failed to load posts: {error}</p>
            </div>
          ) : (
            <div className="caseStudy_grid">
              {posts.map((post) => (
                  <div className="caseStudy_item" key={post.slug}>
                    <Link to={`/case-study/${post.slug}`} className="sc_inner">
                      <div className="cs_thumbnail">
                        {post.featureImage?.url && (
                          <img
                            src={post.featureImage.url}
                            alt={post.title}
                            className="w-full"
                          />
                        )}
                      </div>
                      <div className="cs_content">
                        <h3 className="post-title">{post.title}</h3>
                      </div>
                    </Link>
                  </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default CaseStudies;
